<template>
    <div class="lovemap-container-resize">
        <l-map
                ref="map"
                class="love-map-canvas"
                :zoom="zoomValue"
                :center="center"
                :options="{
                       zoomControl: false,
                       gestureHandling: true
                }"
                @update:zoom="zoomUpdated"
                @update:center="centerUpdated"
        >

            <template v-if="redLine === 'ja'">
                <l-polyline
                        ref="polyline"
                        :lat-lngs="polyline.latlngs"
                        :weight="polyline.weight"
                        :color="polyline.color"
                        :dashArray="polyline.dashArray">
                </l-polyline>
            </template>
            <l-marker
                    :lat-lng="point1"
                    :draggable="true"
                    @update:latLng="testFirst"
            >
                <l-icon
                        :icon-anchor="heartCenter"
                        :iconSize="heartSize"
                        :icon-url="heartImg">
                </l-icon>
            </l-marker>
            <l-marker
                    :lat-lng="point2"
                    :draggable="true"
                    @update:latLng="testSecond"
            >
                <l-icon
                        :icon-anchor="heartCenter"
                        :iconSize="heartSize"
                        :icon-url="heartImg">
                </l-icon>
            </l-marker>

            <TxTileLayer v-if="isWebGlEnabled" :template-name="mapStyle"/>
            <l-tile-layer v-else :url="mapTileServer"/>

        </l-map>
    </div>
</template>

<script>
    import {LIcon, LMap, LMarker, LPolyline, LTileLayer} from 'vue2-leaflet';
    import {sync} from 'vuex-pathify'
    import "leaflet-gesture-handling";
    import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";

    import {distance, modifyLinePoints} from '../helpers/points'

    import LovemapModule from '../store-mixin'

    export default {
        name: 'LoveMap',
        mixins: [LovemapModule()],
        watch: {
            mapSize: 'prepareMap',
            mapLayout: 'prepareMap',
            point1: {
                handler: function (newValue, oldValue) {
                    this.$nextTick(() => {
                        if (!this.presetSelected && this.$root.env !== 'renderer' && this.init) {
                            this.$refs.map.mapObject.flyToBounds([newValue, this.point2], {padding: [200, 200]}); //TODO Fix Padding For Landscape Mode
                        }
                        this.$nextTick(() => {
                            this.distance = distance(newValue, this.point2);
                        })
                    });
                },
            },
            point2: {
                handler: function (newValue, oldValue) {
                    this.$nextTick(() => {
                        if (!this.presetSelected && this.$root.env !== 'renderer' && this.init) {
                            this.$refs.map.mapObject.flyToBounds([this.point1, newValue], {padding: [200, 200]}); //TODO Fix Padding For Landscape Mode
                        }
                        this.$nextTick(() => {
                            this.distance = distance(this.point1, newValue);
                        })
                    })
                },
            },
        },
        data() {
            return {
              init: false,
                size: {
                    height: 0,
                    width: 0,
                },
                bounds: null,
            };
        },
        components: {
            LMap,
            LTileLayer,
            LMarker,
            LIcon,
            LPolyline,
        },
        mounted() {
            this.prepareMap();
            this.$nextTick(()=>{
              this.init = true
            })
        },
        created() {
            window.addEventListener('resize', this.onResizeEnd, {passive: true});
        },
        methods: {
            prepareMap() {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$refs?.polyline?.mapObject?.bringToFront();
                        this.$refs.map.mapObject.invalidateSize();
                    }, 400)
                })
            },
            testFirst(event) {
                this.point1 = Object.values(event)
            },
            testSecond(event) {
                this.point2 = Object.values(event)
            },
            onResizeEnd(event) {
                this.$refs.map.mapObject.invalidateSize();
                this.$refs.map.mapObject.getCenter();
            },
            zoomUpdated(zoom) {
                this.zoom = zoom;
            },
            centerUpdated(center) {
                this.center = Object.values(center);
            },
        },
        computed: {
            zoomValue() {
                return Number(this.zoom)
            },
            mapTileServer() {

                let tileConfig = {
                    lovemap: this.url,
                    'city-map': this.citymap_tile_url,
                    osm: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
                };

                return tileConfig[this.mapStyle]
            },
            isWebGlEnabled() {
                return this.$root.lovemap.webgl !== 'false'
            },
            heartImg() {
                return this.$canUseWebP() ? this.$root.lovemap.heart : this.$root.lovemap.heart.replace('.webp', '.png')
            },
            heartSize() {
                return [
                    41 * this.heartMultiplier,
                    41 * this.heartMultiplier
                ]
            },
            heartCenter() {
                let [x, y] = this.heartSize;
                return [
                    x / 2,
                    y / 2
                ]
            },
            polyline() {
                let [point1, point2] = modifyLinePoints(this.point1, this.point2, this.zoom, this.heartMultiplier)

                return {
                    latlngs: [point1, point2],
                    color: '#d20000',
                    weight: 5,
                    dashArray: '15',
                };
            },
            url() {
                return `${lovemap.config.tile_url}`
            },
        },
    }
</script>

<style lang="scss">

    .leaflet-control-attribution {
        &.leaflet-control {
            display: none;
        }
    }

    .lovemap-container-resize {
        width: 100%;
        height: 100%;
    }

    .love-map-canvas {
        position: absolute;
        width: 100%;
        height: 100%;
    }

    .leaflet-overlay-pane {
        z-index: 4000;
    }
</style>

